export const customDevPageBannerData = {
    mainHeading: "Custom Software",
    mainHeadingGreenText: "Development Services",
    subHeadingGreen: "Trusted by Startups, SMBs, & Enterprises Around the Globe",
    sectionDescripton: "Let us take your eureka moment from a raw concept to feasibility assessment, & from design to development. Our custom software development services offer robust, secure, scalable solutions to ensure sustainable growth for your business.",
    bannerButtonText: "Let's Get Started"
}

export const customSoftwareDevelopmentPageServices = {
    shortHeading: "Our Services",
    mainHeading: "Our Comprehensive Custom Software Development Services",
    description: "We deliver bespoke software solutions designed to align with your unique business needs. From concept to deployment & ongoing support, our services ensure scalability, security, & innovation at every stage of development.",
    cardsData: [
        {
            "title": "Custom Software Development",
            "description": "End-to-end tailored software solutions built to solve your specific business challenges with scalability & reliability."
        },
        {
            "title": "Enterprise Software Solutions",
            "description": "Robust, secure, & scalable enterprise-grade systems that streamline processes & drive organizational efficiency."
        },
        {
            "title": "Software Product Development",
            "description": "From MVPs to full-scale products, we design, develop, & launch innovative software products ready for market success."
        },
        {
            "title": "Legacy System Modernization",
            "description": "Upgrade outdated systems with modern technologies to improve performance, security, & user experience."
        },
        {
            "title": "Technology Consulting",
            "description": "Strategic advice on software architecture, stack selection, & best practices to future-proof your digital initiatives."
        }
    ]
}

export const customDevPageCoverTheStack = {
    CoverTheStackContent: {
        mainHeading: "Optimize Your Software Solutions with Industry-Leading Tech Stack",
        sectionDescription: "Leverage the latest technologies to power your custom software development. Our cutting-edge tech stack ensures scalable, secure, & efficient software solutions tailored to your business needs.",
        defaultTabOpen: "Frontend"
    },

    tabs: [
        "Frontend",
        "Backend",
        "Libraries",
        "Database",
    ],

    tabItems: [
        { tab: "Frontend", icon: "/images/iconthree.png", name: "React JS" },
        { tab: "Frontend", icon: "/images/iconone.png", name: "Angular JS" },
        { tab: "Frontend", icon: "/images/icon7.png", name: "HTML5" },
        { tab: "Frontend", icon: "/images/icon6.png", name: "CSS3" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/gatsby.svg", name: "Gatsby" },
        { tab: "Frontend", icon: "/images/icon4.png", name: "Vue JS" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/ember.svg", name: "Ember.js" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/svelte.svg", name: "Svelte" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/backbone-js.svg", name: "Backbone.js" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/polymer.svg", name: "Polymer" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/aurelia.svg", name: "Aurelia" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/meteor.svg", name: "Meteor.js" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/next-js.svg", name: "Next.js" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/semantic.svg", name: "Semantic-UI" },
        { tab: "Frontend", icon: "/images/tech-stack-icons/nuxt-js.svg", name: "Nuxt" },
        { tab: "Backend", icon: "/images/database9.png", name: "Node Js" },
        { tab: "Backend", icon: "/images/tech-stack-icons/elixir.svg", name: "Elixir" },
        { tab: "Backend", icon: "/images/database1.png", name: ".Net" },
        { tab: "Backend", icon: "/images/database6.png", name: "Python" },
        { tab: "Backend", icon: "/images/tech-stack-icons/ruby_on_rails.svg", name: "Ruby On Rails" },
        { tab: "Backend", icon: "/images/tech-stack-icons/java.svg", name: "Java" },
        { tab: "Backend", icon: "/images/database8.png", name: "PHP" },
        { tab: "Backend", icon: "/images/django-tech.svg", name: "Django" },
        { tab: "Backend", icon: "/images/tech-stack-icons/golang.svg", name: "Go" },
        { tab: "Backend", icon: "/images/tech-stack-icons/c-sharp.svg", name: "C#" },
        { tab: "Backend", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
        { tab: "Backend", icon: "/images/tech-stack-icons/scala.svg", name: "Scala" },
        { tab: "Backend", icon: "/images/tech-stack-icons/rust.svg", name: "Rust" },
        { tab: "Database", icon: "/images/db5.png", name: "MySQL" },
        { tab: "Database", icon: "/images/tech-stack-icons/couchdb.svg", name: "Couch DB" },
        { tab: "Database", icon: "/images/tech-stack-icons/indexed.svg", name: "Indexed DB" },
        { tab: "Database", icon: "/images/db3.png", name: "MongoDB" },
        { tab: "Database", icon: "/images/db7.png", name: "SQLite" },
        { tab: "Database", icon: "/images/db6.png", name: "MS SQL Server" },
        { tab: "Database", icon: "/images/db1.png", name: "Firebase" },
        { tab: "Database", icon: "/images/tech-stack-icons/swift.svg", name: "Swift" },
        { tab: "Database", icon: "/images/tech-stack-icons/redis.svg", name: "Redis" },
        { tab: "Database", icon: "/images/db8.png", name: "DynamoDB" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/jquery.svg", name: "jQuery" },
        { tab: "Libraries", icon: "/images/iconthree.png", name: "React" },
        { tab: "Libraries", icon: "/images/iconone.png", name: "Angular" },
        { tab: "Libraries", icon: "/images/icon4.png", name: "Vue.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/vue-x.svg", name: "Vue.x" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/rx-js.svg", name: "Rxjs" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/backbone-js.svg", name: "Backbone.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/ember.svg", name: "Ember.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/d3-js.svg", name: "D3.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/redux.svg", name: "Redux" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/lodash.svg", name: "Lodash" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/styled-component.svg", name: "Styled Component" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/emotion.svg", name: "Emotion" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/graphql.svg", name: "Graph QL" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/ant-design.svg", name: "Ant Design" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/inertia.svg", name: "Inertia.js" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/mobx.svg", name: "Mobx" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/web3.svg", name: "Web3" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/Web.svg", name: "WebGL" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/core-ui.svg", name: "Core UI" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/material-ui.svg", name: "Material UI" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/flow-js.svg", name: "Flow.js" },
    ]
};

export const CustomDevelopmentIndustriesHeading = {
    mainHeading: "Industries we serve in Custom Development",
}

export const CustomDevPageFaqData = {
    faqContent: {
        mainHeading: "FAQs",
        sectionDescription: "Get quick answers to your questions about our mobile app development process & services."
    },
    questionAndAnswer: [
        {
            id: "collapseOne",
            question: "How much does it cost to develop custom software?",
            answer:
                "The cost of developing custom software varies based on a number of factors, including duration, team allocation, & needs. Commonly, it lies somewhere between $15,000 to $300,000. For an accurate estimate.",
        },
        {
            id: "collapseTwo",
            question: "Why hire a custom software development company?",
            answer:
                "If you are looking to develop customized software tailored to your needs, it is best to hire a company that provides custom software development services.",
        },
        {
            id: "collapseThree",
            question: "How long will it take to complete my custom software?",
            answer:
                "The duration it takes to complete a custom software depends upon various factors including the complexity of the software, the structure, the tech stack, & more. To give you an idea, it can lie anywhere between 4 to 20 months. For an accurate estimate of your project.",
        },
        {
            id: "fourth",
            question: "What if I change the project requirements during the sprint?",
            answer:
                "If you decide to change the project priorities & requirements during an ongoing sprint, we will quickly assess the new changes, create a report based on them, strategize a new plan, & start implementing it after confirmation with key stakeholders.",
        },
        {
            id: "fifth",
            question: "How do you ensure collaboration?",
            answer:
                "Our team is aligned to work in your nearshore time zone & we use premium collaboration tools to prevent any miscommunications & ensure a smooth collaboration. Our PMs have regular meetings with your team to ensure timely & accurate delivery.",
        },
        {
            id: "sixth",
            question:
                "How do you work with delays & difficulties in communication with our business stakeholders?",
            answer:
                "We understand that business stakeholders have tight schedules so we prioritize meetings with proper agendas. Our team takes everything that needs to be discussed into account & with clear priorities, make the meetings count. Another fact is that most of these meetings are needed at the requirement-gathering stage & as the project develops, there is a lesser need for them.",
        },
    ]
}

export const CustomDevPageTypesOfBuildData = {
    TypesOfBuildContent: {
        mainHeading: "Step-by-Step Approach to a Successful Project",
        sectionDescripton: "Discover tailored software solutions, from design to deployment, crafted to meet your unique business needs",
    },
    TypesOfBuildDataAccordian: [
        {
            id: "collapsenine",
            question: "Development Services",
            answer: {
                discription:
                    "We craft software solutions that align with your goals, delivering tailored services for everything from front-end design to back-end development & beyond.",
                listTitle: "",
                listContent: [],
            },
        },
        {
            id: "collapseOne",
            question: "Requirement Gathering",
            answer: {
                discription:
                    "Understanding your needs is where it all begins. We work closely with you to gather every detail, ensuring our custom software development meets your exact requirements.",
                listTitle: "",
                listContent: [],
            },
        },
        {
            id: "collapseTwo",
            question: "Analysis & Planning",
            answer: {
                discription:
                    "Planning makes everything better! We analyze your requirements & map out a clear strategy, ensuring your software is scalable, efficient, & perfectly aligned.",
            },
        },
        {
            id: "collapseThree",
            question: "UI / UX Design",
            answer: {
                discription:
                    "Design isn’t just about looks—it’s about creating experiences. We focus on intuitive, user-friendly designs that make your software solutions engaging & easy to use.",
            },
        },
        {
            id: "fourth",
            question: "Development",
            answer: {
                discription:
                    "Here’s where ideas come to life! Our development process is focused on building reliable & scalable software that works seamlessly & grows with your business.",
            },
        },
        {
            id: "fifth",
            question: "QA & Testing",
            answer: {
                discription:
                    "We test everything rigorously to ensure your software is bug-free & runs perfectly. Quality assurance is how we deliver reliable software solutions you can trust.",
            },
        },
        {
            id: "Sixth",
            question: "Deployment",
            answer: {
                discription:
                    "When it’s ready, we make sure everything is set for a smooth launch. From final checks to real-time deployment, we ensure your software is up & running flawlessly.",
            },
        },
        {
            id: "seventh",
            question: "Maintenance & Upgrades",
            answer: {
                discription:
                    "Our work doesn’t end at delivery. We provide ongoing support, regular updates, & upgrades to ensure your software stays current, efficient, & ready for the future.",
            },
        },
    ]
}

export const CustomDevPageWhoWeServeData = {
    whoWeServeContent: {
        mainHeading: "Who We Serve",
        sectionDescripton: "We create tailored software services for startups, product companies, & enterprises across industries."
    },

    WhoWeServeCards: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "Startups",
            description:
                "We help startups bring their ideas to life with scalable software & custom app solutions designed to grow with their business needs.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "Software product companies",
            description:
                "Empowering product companies with tailored software services, from design to deployment, ensuring seamless user experiences & scalability.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "Enterprises from 30+ industries",
            description:
                "Transforming enterprises with custom software development & scalable software solutions across diverse industries & challenges.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const customDevPageHighvaluesData = {
    highValueContent: {
        mainHeading: "High-Value Features for High-Performance Custom Software Solutions",
        sectionDescripton: "Our custom software development delivers high-performance solutions tailored to your needs. From expert teams to scalable designs, we ensure quality, innovation, & seamless integration to elevate your business success.",
        buttonText: "Consult Project Scope"
    },
    highvaluesDataCards: [
        {
            image: "custom-app-development.svg",
            text: "Custom App Development",
        },
        {
            image: "user-centric-designs.svg",
            text: "User-Centric Designs",
        },
        {
            image: "robust-architecture.svg",
            text: "Robust Architecture",
        },
        {
            image: "efficient-integration.svg",
            text: "Efficient Integration",
        },
        {
            image: "advanced-analytics.svg",
            text: "Advanced Analytics",
        },
        {
            image: "enhanced-security.svg",
            text: "Enhanced Security",
        },
        {
            image: "agile-methodology.svg",
            text: "Agile Methodology",
        },
        {
            image: "cross-platform-support.svg",
            text: "Cross-Platform Support",
        },
        {
            image: "ongoing-maintenance.svg",
            text: "Ongoing Maintenance",
        },
        {
            image: "innovation-driven-features.svg",
            text: "Innovation-Driven Features",
        },
    ]
}

export const CustomDevPageWhyChooseBitsclanData = {
    whyChoseBitsclanContent: {
        mainHeading: "Why Choose Bitsclan as Your Custom Software Development Company?",
        sectionDescripton: "At Bitsclan, we deliver tailored software services built to meet your unique needs. From expert talent & time zone alignment to quality & scalability, our custom software development ensures seamless solutions for businesses of all sizes."
    },
    whyChoseBitsclanTabs: [
        {
            id: "Tab1",
            label: "Quality Because It Matters",
            content:
                "At Bitsclan, quality isn’t just a process—it’s the heartbeat of everything we do. We specialize in building high-performance, scalable, & robust software solutions that are custom-tailored to meet the unique demands of your business.",
            content2:
                "From the earliest brainstorming sessions to the final deployment & beyond, we apply meticulous attention to detail & industry best practices to ensure your software is efficient, secure, & built for long-term success. We don’t just meet expectations—we consistently exceed them.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "The Best-of-the-Breed Talent",
            content:
                "Our strength lies in our people. Bitsclan brings together a team of highly skilled developers, UI/UX designers, software architects, & engineers who possess deep technical knowledge & cross-industry experience.",
            content2:
                "From innovative startups to complex enterprise systems, our experts deliver intelligent, scalable, & impactful solutions using the latest tools, technologies, & methodologies. Every project is driven by creativity, precision, & a genuine passion for technology.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "Time Zone Alignment for Seamless Collaboration",
            content:
                "Global clients demand real-time responsiveness—and we deliver. Our globally distributed teams operate in alignment with your time zone, ensuring prompt communication & seamless coordination at every step.",
            content2:
                "Whether it's daily stand-ups, project updates, or on-the-fly changes, our workflow adapts to your schedule, eliminating bottlenecks & enhancing project momentum. We work as an extension of your team, no matter where you are in the world.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "Up-to-Date Technology for Future-Proof Solutions",
            content:
                "In today’s rapidly evolving tech landscape, staying current is not optional—it’s essential. Our team continuously explores emerging technologies to ensure the solutions we build are relevant today & adaptable for tomorrow.",
            content2:
                "Whether it’s cloud-native development, AI-driven automation, blockchain integration, or modern front-end frameworks, we implement cutting-edge tools & practices to deliver software that performs today & thrives in the future.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "Commitment to Excellence",
            content:
                "We don’t just build software—we build trust. At Bitsclan, every project is approached with a deep sense of ownership, responsibility, & passion for excellence. Your goals become our mission.",
            content2:
                "From in-depth requirement gathering & agile execution to post-deployment optimization & support, we go the extra mile to ensure your solution is powerful, reliable, & aligned with your long-term business strategy.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
    ]
}

export const CustomDevelopmentPageServicesData = {
    developmentServicesContent: {
        mainHeading: "Our Expansive Range of End-to-end Custom Software Development Services.",
        sectionDescripton: "We create software solutions that truly work for you—whether it’s building custom cloud platforms, interactive portals, or crafting seamless front-end & reliable back-end systems. Our tailored software services are built to grow with your business. From expert consulting to scalable e-commerce development, we deliver secure & flexible solutions designed to meet your unique needs."
    },
    developmentServicesTabs: [
        {
            id: "Tab1",
            label: "Web Portals That Work for You",
            content:
                "Web portals serve as a centralized digital hub for businesses, providing employees, customers, & stakeholders with seamless access to essential information & services. Whether it's an internal portal for team collaboration, a customer self-service portal, or an e-commerce management system, web portals improve efficiency & streamline operations.",
            secondContent: "Custom web portal development ensures tailored features like role-based access, real-time data sharing, interactive dashboards, & secure authentication. With a user-centric design & smooth integration with third-party tools, a well-built web portal enhances engagement, improves workflow automation, & optimizes business processes for better productivity.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab2",
            label: "Strong & Secure Backend Systems",
            content:
                "A strong & secure backend is the backbone of any digital application, ensuring seamless functionality, data integrity, & system reliability. Backend systems handle data processing, authentication, business logic, & server-side operations, allowing applications to run smoothly without disruptions.",
            secondContent: "By leveraging technologies like FastAPI, GraphQL, Angular, & MySQL, businesses can build scalable & high-performance backend solutions. Security measures such as encryption, API authentication, & database optimization ensure data protection & compliance with industry standards. A well-structured backend architecture supports future growth, enabling businesses to scale their applications effortlessly.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab3",
            label: "Easy-to-Use Frontend Experiences",
            content:
                "A visually appealing & intuitive frontend is essential for engaging users & delivering a seamless digital experience. Frontend development focuses on creating user-friendly interfaces that enhance accessibility, responsiveness, & ease of navigation across devices.",
            secondContent: "By adopting modern UI/UX principles, businesses can develop aesthetically pleasing designs that maximize usability. Features like interactive elements, real-time updates, & optimized performance contribute to customer satisfaction. Leveraging frameworks like React, Angular, or Vue.js ensures that frontend applications are dynamic, fast-loading, & highly interactive, keeping users engaged & improving conversion rates.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "Smart Software Consulting",
            content:
                "Software consulting plays a crucial role in guiding businesses through technological advancements, ensuring they choose the right solutions for their unique needs. Expert consultants analyze existing workflows, identify inefficiencies, & recommend tailored software solutions that improve operations.",
            secondContent: "A well-planned software strategy helps businesses reduce costs, mitigate risks, & enhance efficiency. Whether it's migrating to cloud-based solutions, optimizing system architecture, or integrating automation tools, software consulting provides the expertise needed to implement effective digital transformation. Through a structured approach, businesses can stay ahead of the competition & leverage technology to drive growth.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "Custom Software for Enterprises",
            content:
                "Enterprise software solutions are designed to address specific business needs, providing automation, data management, & streamlined processes. Unlike off-the-shelf solutions, custom software offers flexibility, scalability, & security to meet the demands of large-scale operations.",
            secondContent: "Tailored enterprise applications enable businesses to optimize workflows, integrate multiple systems, & ensure seamless communication across departments. From customer relationship management (CRM) systems to enterprise resource planning (ERP) solutions, custom software enhances productivity, reduces operational inefficiencies, & improves decision-making through real-time analytics & reporting.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "Flexible Headless CMS Solutions",
            content:
                "A headless CMS separates content management from the front-end display, giving businesses complete control over how their content is delivered across multiple platforms. This flexibility is crucial for companies managing content across websites, mobile apps, IoT devices, & other digital channels.",
            secondContent: "With a headless CMS, businesses can streamline content distribution, ensuring consistency across different platforms while enabling faster updates & scalability. It allows developers to use APIs to fetch content dynamically, providing improved performance & a seamless user experience. Headless CMS solutions empower content creators with easy-to-use tools while offering developers the freedom to design custom front-end experiences.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/custom-development/fast-api.png",
                },
                {
                    img: "/images/services-icons/custom-development/GraphQL-logo.png",
                },
                {
                    img: "/images/services-icons/custom-development/angular-icon.png",
                },
                {
                    img: "/images/services-icons/custom-development/mysql-logo.png",
                },
            ],
        },
    ]
}

export const customDevelopmentPageRoadMapData = {
    roadMapStepsContent: {
        mainHeading: "Our Proven Roadmap to Ensure Your Success",
        sectionDescripton: "Our roadmap ensures success at every stage of your custom software development journey. From planning to testing, we deliver tailored software services designed to meet your unique goals with precision & care."
    },
    roadMapStepsHeading: [
        "Discovery & Planning",
        "Design & Proof of Concept",
        "Development & Testing",
        "Implementation & Support"
    ],
    roadMapStepsDescription: [
        "We align with your vision, creating a roadmap that ensures efficient development, scalability, & business-focused custom software solutions.",
        "Turn ideas into reality! We create designs & proofs of concept, ensuring feasibility & aligning the solution with your needs & expectations.",
        "Our robust development & rigorous testing deliver secure & reliable custom app solutions while ensuring optimal performance & scalability.",
        "We focus on smooth implementation & provide continuous support, ensuring your scalable software meets long-term operational goals seamlessly.",
    ]
}

export var mainBannerImg = {
    backgroundImage: `url(/images/what-we-do/custom-software-development.avif)`,
};

export const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
        {
            "@type": "Question",
            name: "Why hire a custom software development company?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "If you are looking to develop customized software tailored to your needs, it is best to hire a company that provides custom software development services.",
            },
        },
        {
            "@type": "Question",
            name: "How much does it cost to develop custom software?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "The cost of developing custom software varies based on a number of factors, including duration, team allocation, & needs. Commonly, it lies somewhere between $15,000 to $300,000. For an accurate estimate, we recommend you talk to our experts.",
            },
        },
        {
            "@type": "Question",
            name: "How long will it take to complete my custom software?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "The duration it takes to complete a custom software depends upon various factors including the complexity of the software, the structure, the tech stack, & more. To give you an idea, it can lie anywhere between 4 to 20 months. For an accurate estimate of your project, talk to the experts.",
            },
        },
        {
            "@type": "Question",
            name: "What if I change the project requirements during the sprint?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "If you decide to change the project priorities & requirements during an ongoing sprint, we will quickly assess the new changes, create a report based on them, strategize a new plan, & start implementing it after confirmation with key stakeholders.",
            },
        },
        {
            "@type": "Question",
            name: "How do you ensure collaboration?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Our team is aligned to work in your nearshore time zone & we use premium collaboration tools to prevent any miscommunications & ensure a smooth collaboration. Our PMs have regular meetings with your team to ensure timely & accurate delivery.",
            },
        },
        {
            "@type": "Question",
            name: "How do you work with delays & difficulties in communication with our business stakeholders?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "We understand that business stakeholders have tight schedules so we prioritize meetings with proper agendas. Our team takes everything that needs to be discussed into account & with clear priorities, make the meetings count. Another fact is that most of these meetings are needed at the requirement-gathering stage & as the project develops, there is a lesser need for them.",
            },
        },
    ],
};